import { render } from "./DateComponent.vue?vue&type=template&id=052612cb"
import script from "./DateComponent.vue?vue&type=script&lang=js"
export * from "./DateComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__